import React from 'react';
import { ClassComponentRegistry } from '../../utils/ClassComponentRegistry';
import { initializeClassProviders } from '../../providers';
import { useTheme } from '../../theme';

const ClassSectionDiagnostic: React.FC = () => {
  // Initialize providers when component mounts
  React.useEffect(() => {
    initializeClassProviders();
  }, []);

  const testClasses = ['brawler', 'warrior', 'guardian', 'ranger', 'rogue', 'seraph', 'sorcerer', 'wizard', 'druid', 'bard'];
  
  return (
    <div style={{ padding: 'var(--semantic-spacing-component-lg)', fontFamily: 'monospace' }}>
      <h2>Class Section Diagnostic</h2>
      
      <div style={{ marginBottom: 'var(--semantic-spacing-component-lg)' }}>
        <h3>Registered Classes:</h3>
        <pre>{JSON.stringify(ClassComponentRegistry.getRegisteredClasses(), null, 2)}</pre>
      </div>
      
      {testClasses.map(className => {
        const sections = ClassComponentRegistry.getCharacterSheetSections(className);
        const combatComponents = ClassComponentRegistry.getCombatTrackerComponents(className);
        
        return (
          <div key={className} style={{ marginBottom: 'var(--semantic-spacing-component-md)', border: 'var(--semantic-border-width-default) solid var(--semantic-colors-border-default)', padding: 'var(--semantic-spacing-component-sm)' }}>
            <h3>{className.charAt(0).toUpperCase() + className.slice(1)} Class</h3>
            <div>
              <strong>Character Sheet Sections ({sections.length}):</strong>
              <ul>
                {sections.map((section, index) => (
                  <li key={index}>
                    {section.title} - Priority: {section.priority} - Order: {section.order} - Self-contained: {section.selfContained ? 'Yes' : 'No'}
                  </li>
                ))}
                {sections.length === 0 && <li>No sections found</li>}
              </ul>
            </div>
            <div>
              <strong>Combat Components ({combatComponents.length}):</strong>
              <ul>
                {combatComponents.map((component, index) => (
                  <li key={index}>Order: {component.order}</li>
                ))}
                {combatComponents.length === 0 && <li>No combat components found</li>}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClassSectionDiagnostic;